import React, { useEffect } from "react";
import { Box } from "@mui/material";
import Navbar from "../components/Navbar";
import FlyCodeBanner from "../components/home/FlyCodeBanner";

const ContactForm = () => {
  useEffect(() => {
    // Load Typeform embed script
    const script = document.createElement("script");
    script.src = "//embed.typeform.com/next/embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector(
        'script[src="//embed.typeform.com/next/embed.js"]'
      );
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "#ffffff",
        color: "#000000",
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      <FlyCodeBanner />
      <Navbar />

      <Box
        sx={{
          pt: 12,
          minHeight: "calc(100vh - 100px)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          data-tf-live="01KF6PNBFNC6SEQ4Q966HFYVNA"
          style={{ width: "100%", height: "100%", flex: 1, minHeight: "600px" }}
        ></div>
      </Box>
    </Box>
  );
};

export default ContactForm;
